/* Step 11d-2 · lane D2 (11c Add-on items X1–X7, 01-Nov-2026) — EN + AR texts.
   s11d2.feeds322aOne       X1: the Deficiency Log line for one significant deficiency (pages/DeficiencyLog.jsx; the plural is
                            cd.feeds322a, its "{count}" now filled in on the screen).
   s11d2.jeJob.*            X2: the Journal Entry Testing scan's progress line and job reference in the screen's language
                            (lib/jeJobMessage.js) — the job writes English text, which sat inside the Arabic page.
   s11d2.engagementCurrency X5: a rate-card grade with no currency of its own (pages/Settings.jsx) — the engagement's currency
                            is used when an entry is logged (dsBilling.currencyHint).
   ailog.feature.*          X3: the plain names of the AI features the backend meters that had none (AI Usage, AI log): the
                            screen showed the code humanised ("Far explanation"). */
export default {
  en: {
    s11d2: {
      feeds322aOne: "1 entry feeds 322(a) Management Letter.",
      engagementCurrency: "Engagement currency",
      jeJob: {
        readChunk: "Reading chunk {i} of {n} · {rows} rows read · {time}",
        crossRow: "Cross-row rules {rules} over {rows} in-period rows · {time}",
        scoreChunk: "Scoring chunk {i} of {n} · {rows} rows scored · {time}",
        scored: "Scored {rows} rows in {n} chunk(s) · {time}",
        running: "The scan is running…",
        jobRef: "job {id}…",
      },
    },
    ailog: {
      feature: {
        far_explanation: "Final analytical review — draft explanation",
        methodology_summary: "Methodology summary",
        methodology_settings_suggest: "Methodology settings suggestions",
        report_narrative: "Auditor's report narrative drafting",
      },
    },
  },
  ar: {
    s11d2: {
      feeds322aOne: "يوجد إدخال واحد يُغذّي 322(a) خطاب الإدارة.",
      engagementCurrency: "عملة المهمة",
      jeJob: {
        readChunk: "قراءة الجزء {i} من {n} · قُرئ {rows} سطرًا · {time}",
        crossRow: "القواعد على مستوى الأسطر المتعددة {rules} على {rows} سطرًا داخل الفترة · {time}",
        scoreChunk: "تقييم الجزء {i} من {n} · قُيِّم {rows} سطرًا · {time}",
        scored: "قُيِّم {rows} سطرًا في {n} جزءًا · {time}",
        running: "الفحص قيد التشغيل…",
        jobRef: "المهمة {id}…",
      },
    },
    ailog: {
      feature: {
        far_explanation: "المراجعة التحليلية النهائية — صياغة تفسير",
        methodology_summary: "ملخص المنهجية",
        methodology_settings_suggest: "اقتراحات إعدادات المنهجية",
        report_narrative: "صياغة سرد تقرير المراجع",
      },
    },
  },
};
